import React from "react";
import Image from "components/Elements/Image/Image.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip";
import Settings from "./Settings";
import AnimationContainer from "components/Reusable/AnimationContainer/AnimationContainer";
import { panelList } from "../../Helpers/JsonLists.js";
import "./EmebdPageSidePanel.scss";
const SidePanel = (props) => {
  return (
    <div className={`side-panel side-panel-step-4`}>
      <ul className="side-panel-ul">
        {panelList.map((item, i) => (
          <li
            id={`page-edit_side-panel-${item.name}`}
            className={`type-${item.name} ${
              props.typeOfSettings === item.name ? "active" : ""
            }`}
            key={i}
            onClick={() => {
              props.openSidePanel(item.name);
            }}
          >
            <Tooltip id={item.tooltip} tooltipTextKey={item.tooltip} right>
              <Image name={item.image} alt="" title="" ext="png" />
            </Tooltip>
          </li>
        ))}
      </ul>
      <AnimationContainer
        animationOn={props.isOpen}
        animationClassName="side-bar-animation"
      >
        {props.typeOfSettings && (
          <Settings
            FullDetailsEmbedPage={props.FullDetailsEmbedPage}
            setTypeOfSettings={props.setTypeOfSettings}
            type={props.typeOfSettings}
            setIsOpen={props.setIsOpen}
            isDefaultBackgrounds={props.isDefaultBackgrounds} //DESIGN
            setBackgroundImagesList={props.setBackgroundImagesList}
            backgroundImagesList={props.backgroundImagesList}
            setSingleOrRotate={props.setSingleOrRotate}
            singleOrRotate={props.singleOrRotate}
            setBrandingColor={props.setBrandingColor}
            brandingColor={props.brandingColor}
            pageLanguage={props.pageLanguage}
            setPageLanguage={props.setPageLanguage}
            displayFormDetialsDB={props.displayFormDetialsDB}
            setDisplayFormDetialsDB={props.setDisplayFormDetialsDB}
            displaySidePanel={props.displaySidePanel}
            setDisplaySidePanel={props.setDisplaySidePanel}
            EmbedPageFormList={props.EmbedPageFormList} //FORMS
            setEmbedPageFormList={props.setEmbedPageFormList}
            selectedForms={props.selectedForms}
            setSelectedForms={props.setSelectedForms}
            showOrderTracker={props.showOrderTracker}
            setShowOrderTracker={props.setShowOrderTracker}
            userFormsList={props.userFormsList}
            diractionPage={props.diractionPage}
            setDiractionPage={props.setDiractionPage}
            socialLinks={props.socialLinks} //SOCIAL
            personalPageUrl={props.personalPageUrl}
            browserTitle={props.browserTitle} //SEO
            setBrowserTitle={props.setBrowserTitle}
            headScripts={props.headScripts}
            setHeadScripts={props.setHeadScripts}
            metaDescription={props.metaDescription}
            setMetaDescription={props.setMetaDescription}
            bodyScripts={props.bodyScripts}
            setBodyScripts={props.setBodyScripts}
            searchEngines={props.searchEngines}
            setSearchEngines={props.setSearchEngines}
          />
        )}
      </AnimationContainer>
    </div>
  );
};

export default SidePanel;
